import React, { useState } from "react"
import Loading from "src/app/admin/loading"
import Pagination from "src/components/tailwind-components/Pagination"
import { useGetTransferApplications } from "../hooks/useGetTransferApplications"
import TransferApplicationItem from "./TransferApplicationItem"

interface TransferApplicationsListProps {
  transferApplicationId: number | undefined
}

const TransferApplicationsList: React.FC<TransferApplicationsListProps> = ({
  transferApplicationId,
}) => {
  const [page, setPage] = useState(1)
  const { transferApplications, pagination, isLoading, mutate } = useGetTransferApplications({
    transferApplicationId,
    page,
  })

  if (isLoading) return <Loading />

  return (
    <div className="mx-auto w-full">
      {/* ページネーション */}
      <div className="pb-4">
        <Pagination pagination={pagination} onPageChange={setPage} />
      </div>
      {/* 申請一覧 */}
      <div className="flex flex-col gap-8">
        {transferApplications &&
          transferApplications.map((application) => (
            <TransferApplicationItem
              key={application.id}
              application={application}
              onUpdate={mutate}
              onCancel={mutate}
            />
          ))}
      </div>

      {/* ページネーション */}
      <div className="pb-8 pt-4">
        <Pagination pagination={pagination} onPageChange={setPage} />
      </div>
    </div>
  )
}

export default TransferApplicationsList
